import type { IconNode } from '../types';

/**
 * @name tie-bow-ribbon
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiB4PSIxMCIgeT0iNyIgLz4KICA8cGF0aCBkPSJNOCA5aDIiIC8+CiAgPHBhdGggZD0iTTEwIDdDOC44IDUuNSA2LjYgNCA0IDQgMi45IDQgMiA2LjIgMiA5cy45IDUgMiA1YzIuNiAwIDQuOC0xLjUgNi0zIiAvPgogIDxwYXRoIGQ9Ik0xNCA5aDIiIC8+CiAgPHBhdGggZD0iTTE0IDExYzEuMiAxLjUgMy40IDMgNiAzIDEuMSAwIDItMi4yIDItNXMtLjktNS0yLTVjLTIuNiAwLTQuOCAxLjUtNiAzIiAvPgogIDxwYXRoIGQ9Ik01LjUgMTMuODMgNCAyMGwzLTEgMiAyIDIuNS0xMCIgLz4KICA8cGF0aCBkPSJNMTguNSAxMy44MyAyMCAyMGwtMy0xLTIgMi0yLjUtMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/tie-bow-ribbon
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tieBowRibbon: IconNode = [
  ['rect', { width: '4', height: '4', x: '10', y: '7', key: 'qbcm6j' }],
  ['path', { d: 'M8 9h2', key: '1g203m' }],
  [
    'path',
    { d: 'M10 7C8.8 5.5 6.6 4 4 4 2.9 4 2 6.2 2 9s.9 5 2 5c2.6 0 4.8-1.5 6-3', key: '24ago' },
  ],
  ['path', { d: 'M14 9h2', key: '116p9w' }],
  [
    'path',
    { d: 'M14 11c1.2 1.5 3.4 3 6 3 1.1 0 2-2.2 2-5s-.9-5-2-5c-2.6 0-4.8 1.5-6 3', key: '1uvcvc' },
  ],
  ['path', { d: 'M5.5 13.83 4 20l3-1 2 2 2.5-10', key: '12v0ra' }],
  ['path', { d: 'M18.5 13.83 20 20l-3-1-2 2-2.5-10', key: 'ulhsq1' }],
];

export default tieBowRibbon;
